window.MailingLists = {

	prepareFilterForm: function () {
		var options = {success: function (data) {MailingLists.processFilterForm(data);
			}, dataType: "json"};
		MyForm.prepare("mailinglistsFilterForm", "massmailing_mailinglist&action=updateListing", options);
	},
	
	processFilterForm: function (data) {
		Listing.refresh("mailinglistsListing", data, data.mailinglists_metadatas);
	}
	
};

window.MailingList = {

	createInfo: function(){
		MyWindow.alert(Loc.g('Pour créer une mailing list, rendez vous dans une liste de contacts. Vous pouvez ensuite utiliser les actions groupées pour créer ou mettre à jour des listes.'), {type:'warning'})
	},

	editNameEIP: function(){
	
		var container 	= $('#mailingListOverview');
		var listId 		= $('#currentMailingListId').val();
		
		container.find('.EIP_displayer').hide();
		container.find('.EIP_editor').show().focus();
		
		container.find('.EIP_editor').keypress(function(e) {
			if(e.which == 13) {
				var newValue = 	container.find('.EIP_editor').val();
				if (newValue != ""){
					container.find('.EIP_displayer').html(newValue).show();
					container.find('.EIP_editor').hide();
					MyFacture.post("massmailing_mailinglist", {action:"updateMailingListName", newName:newValue, listId:listId}, function(data){
						Listing.update('mailinglistsListing')
					}, "json");
				}
			}
			
			if (e.which == 27){
				container.find('.EIP_editor').hide();
				container.find('.EIP_editor').show();
			}
			
		});
		
	},

	deleteContact: function(mailingListContentId){
		
		var options = {
			type:  "warning",
			buttons : [
				{
					text : Loc.g("Annuler"), 
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Supprimer"), 
					click : function(){
					
						$(this).dialog("close");
						var datas = {action:"removeFromMailingList", mailingListContentId:mailingListContentId};
						MyFacture.post("massmailing_mailinglist", datas, function(data){
							
							Listing.update("mailinglistscontentlistListing");
							
						}, "json");
						
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("Supprimer le contact de la liste ?"), options);
	
	},

	initPopupContentListing : function(){
	
		MyFacture.initEvent();				
		Listing.init("mailinglistscontentlistListing");

		
		var options = {
			data : {action : 'updateListingContentOverview'},
			success: function (data) {
				Listing.refresh(data.prefix, data, data[data.metadatasName]);
			},
			dataType: "json"
		};
		MyForm.prepare("mailinglistscontentlistFilterForm", "massmailing_mailinglist", options);
	},

	addToOneFormOverview: function(){
	
		var listId 		= $('#currentMailingListId').val();
		var thirds 		= $('#addThirdToList').tokenInput('get');
		var contacts 	= $('#addContactToList').tokenInput('get');
		
		var rowSelection = [];
		
		$.each(thirds, function(i,v){
			rowSelection.push(v.id);
		});
		
		$.each(contacts, function(i,v){
			rowSelection.push('contact_' + v.id);		
		});
		
		var datas = {
			action :				'addToMailingList',
			mailinglist_type :		'existing',
			mailinglist_listID :	listId,
			rowSelection :			rowSelection
		};

		MyFacture.post("massmailing_mailinglist", datas, function(data){
			
			$('#addContactToList').tokenInput('clear');
			$('#addThirdToList').tokenInput('clear');
			  
			if (data.success == 'ok') {
				var formOk = MyForm.processJson(data, 'mailingListForm');

				if(formOk){
					MailingList.buildMailingListAddReport(data);
					Listing.update("mailinglistscontentlistListing");
				}
			} else if (data.success == 'notOk') {
				Push.error(data.message);
			}
			
		}, "json");
	
	},

	addToOne : function(rowSelection){
		
		var formID = "mailingListForm";
		
		var data = {
			action		: "addToMailingListForm", 
			rowSelection : rowSelection,
		};
		
		var options = {
			title :  Loc.g('Ajouter à la mailingList'),
			buttons:
					[
						{
							text: Loc.g("Annuler"), 
							click: function() {
								$(this).dialog("close");
							},
							'class' : 'btn-default'
						},
						{
							text: Loc.g("Enregistrer"), 
							click: function() {
								$("#" + formID).submit();
							},
							'class' : 'btn-primary',
						}
					],
			width: 600,
			callback: function() {
				
				var options = {
					data : {
						action :			'addToMailingList',
						'rowSelection[]' :	rowSelection
					},
					dataType :	'json',
					success :	function(data){
						if (data.success == 'ok') {
							var formOk = MyForm.processJson(data, formID);

							if(formOk){
								MyWindow.close();
								MailingList.buildMailingListAddReport(data);
							}
						} else if (data.success == 'notOk') {
							MyWindow.close();
							Push.error(data.message);
						}
					}
				};
				
				MyForm.prepare(formID, 'massmailing_mailinglist', options, true);
				MyFacture.customForm('#'+formID);
			}
		};
		
		MyWindow.load("massmailing_mailinglist", data, options);
	},

	buildMailingListAddReport: function(data){

		var report = $('<div><div class="content_grid"><div class="row gutters1"><div id="added" class="col span_6"></div><div id="existing" class="col span_6"></div></div></div></div>');

		var reportType = ['added', 'existing'];

		reportType.forEach(function(type){

			switch (type) {
				case 'added':
					var title		= Loc.g('Contacts ajoutés à la mailing list');
					var placeholder	= Loc.g('Aucun contact n‘a été ajouté à la mailing list');
					break;
				case 'existing':
					var title		= Loc.g('Contacts déjà existants dans la mailing list');
					var placeholder	= Loc.g('Tous les contacts sélectionnés ont été ajoutés à la mailing list');
					break;
			}

			report.find('#'+type).append('<h4>'+title+'</h4>');

			if (data.report[type].length > 0) {
				report.find('#'+type).append('<ul class="well mt-0"></ul>');

				for(var cpt in data.report[type]){
					report.find('#'+type+' ul').append('<li class="pb-1">'+data.report[type][cpt]+'</li>');
				}

			} else {
				report.find('#'+type).append('<div class="well mt-0 acenter">'+placeholder+'</div>');
			}

		});

		MyWindow.alert(report.html(), { width: 800, type: 'confirm'});

	},

	loadOverview : function(mmlid){
	
		var data = {
			action	: "overview", 
			mmlid	: mmlid
		};
		
		var options = {
			title :  Loc.g('Aperçu de la Mailing List'),
			buttons:
					[
						{
							text: Loc.g("Fermer"), 
							click: function() {
								$(this).dialog("close");
							},
							'class' : 'btn-default'
						}
					],
			width: 1340,
			callback: function() {
				
				MailingList.initPopupContentListing();
				
			}
		};
		MyWindow.load("massmailing_mailinglist", data, options, 'mailingListContentOverview');
		
	},
		
	changeToExisting : function(){
		$('#mailinglist_typeExisting').attr('checked', true);
	},
	
	deleteOne: function(listId){
		
		MyFacture.post("massmailing_mailinglist", {action:"isMailingListDeletable", listId:listId}, function(data){
			
			if (data.isDeletable == 'Y'){
				
				var options = {
					title 	: Loc.g('Supprimer la Mailing List'),
					type	: 'warning',
					buttons :
							[
								{
									text: Loc.g("Annuler"), 
									click: function() {
										$(this).dialog("close");
									},
									'class' : 'btn-default'
								},
								{
									text: Loc.g("Supprimer"),
									click: function() {
									
										$(this).dialog("close");
										MyFacture.post("massmailing_mailinglist", {action:"deleteMailingList", listId:listId}, function(data){
										
											if ($('#mailinglistsListing_container').length > 0){
												Listing.update('mailinglistsListing');
											} else {
												Utils.reload();
											}
											
										}, "json");
									
									},
									'class' : 'btn-default'
								}
								
							],
					
				};
				
			
				MyWindow.alert(Loc.g("Êtes vous sur de vouloir supprimer cette Mailing List ?"), options);
			} else {
				MyWindow.alert(Loc.g("Cette Mailing List est utilisée dans des campagnes. Elle n'est donc pas supprimable"), {type:'error'});
			}
			
		}, "json");
	}
};